export const DROP_CLEAN_SYMBOL =
  'https://storage.helloreaddy.io/project_files/a43e5cb1-fd9e-44b6-ad6e-f24d6cf0ed53/6ba60e3e-d52c-435c-a81f-9cb1de2427e4_compressed_Drop-Clean-Symbol3x.webp';

export const DROP_CLEAN_FULL_LOGO =
  'https://storage.helloreaddy.io/project_files/a43e5cb1-fd9e-44b6-ad6e-f24d6cf0ed53/0e84704c-573e-433c-88cc-5aca87dcccd3_compressed_Drop-Clean-Full-Logo3x.webp';

interface BrandMarkProps {
  size?: number;
  className?: string;
}

export function BrandMark({ size = 40, className = '' }: BrandMarkProps) {
  return (
    <span
      className={`inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={DROP_CLEAN_SYMBOL}
        alt="شعار Drop Clean"
        title="Drop Clean — خدمات الغسيل والكوي"
        className="h-full w-full object-contain"
      />
    </span>
  );
}

interface BrandFullLogoProps {
  className?: string;
}

export function BrandFullLogo({ className = '' }: BrandFullLogoProps) {
  return (
    <img
      src={DROP_CLEAN_FULL_LOGO}
      alt="Drop Clean"
      title="Drop Clean — شريكك في تقديم أفضل خدمة"
      className={`object-contain ${className}`}
    />
  );
}